import { jsx, jsxs } from "react/jsx-runtime";
import { f as PropTypes, d as Skeleton, c as OfferLogo, P as ProviderHighlights, O as OfferCriteria, b as OfferCta, g as addQueryParams } from "./Button-BcmY_3eC.js";
import { E as ENVIRONMENTS, a as useIsTestMode, u as useFetchOffers } from "./useFetchOffers-DDGQWBv9.js";
import "react";
import { Box } from "@mui/material";
import { styled as styled$1 } from "@mui/material/styles";
import { l as TOTAL_SKELETON_LOADER_CARDS, m as MKT_OFFER_CONTAINER, h as MKT_CONTAINER_ID, n as MKT_GRID_TEMPLATE_AREAS, o as MKT_GRID_COLUMN_SIZES, g as MKT_CONTAINER_BREAKPOINT, p as MKT_GRID_AREAS, q as MKT_OFFERS_CONTAINER, r as MKT_MINI_BREAKPOINT, V as VARIANTS, s as CUSTOM_OFFER_GRID_COLUMN_SIZES, t as CUSTOM_OFFER_GRID_TEMPLATE_AREAS, u as CUSTOM_OFFER_GRID_AREAS, j as CUSTOM_OFFER_CONTAINER_ID, F as FOCUS_OUTLINE_CLASS } from "./index-WXBJjodC.js";
import "./index-Jj5pKhlE.js";
import { c as getVisibleOffers } from "./marketplace-BNakCyBo.js";
import { styled } from "@mui/system";
import { BREAKPOINT_DIMENSIONS } from "@quickenloans-ui-suite/design-system";
import { m as mockSkeletonMarketplace } from "./MockCustomOfferCardChildren-aHfZ3m0z.js";
import { b as isWindowDefined } from "./index-CJNq9Per.js";
import { BYOButton } from "@cdm/quickenloans-library/lib/";
const StyledSkeletonNavBarDesktop = styled(Box)(
  () => {
    return `
        opacity: 0;    
        animation: navSkeletonDelay 100ms linear 333ms forwards;
            @keyframes navSkeletonDelay {
                0% {
                    opacity: 0;
                },
                100% {
                    opacity: 1
                }
            }
        `;
  }
);
const StyledSkeletonMarketplace = styled(StyledSkeletonNavBarDesktop)(({ theme }) => ({
  display: "flex",
  gap: "24px",
  width: "100%",
  flexDirection: "column",
  "& .MuiSkeleton-root": {
    minHeight: "380px",
    [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.large)]: {
      minHeight: "252px"
    }
  }
}));
const SkeletonMarketplace = ({ sx = {}, totalRows = TOTAL_SKELETON_LOADER_CARDS }) => {
  const baseKey = "skeleton-marketplace";
  return /* @__PURE__ */ jsx(StyledSkeletonMarketplace, { "data-testid": `${baseKey}-container`, sx, children: mockSkeletonMarketplace.slice(0, totalRows).map((option, index) => /* @__PURE__ */ jsx(
    Skeleton,
    {
      "data-testid": `${baseKey}-${index}`,
      ...option
    },
    `${baseKey}-${index}`
  )) });
};
SkeletonMarketplace.propTypes = {
  sx: PropTypes.object,
  totalRows: PropTypes.number
};
const OfferCardContainer = styled$1(Box)(({ theme }) => ({
  [`#${MKT_CONTAINER_ID} &`]: {
    width: "100%",
    minWidth: "272px",
    maxWidth: "1376px",
    container: `${MKT_OFFER_CONTAINER} / inline-size`
  }
}));
const OfferCardLayout = styled$1(Box)(({ theme }) => {
  var _a, _b;
  return {
    [`#${MKT_CONTAINER_ID} &`]: {
      display: "grid",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "repeat(4, auto)",
      gridTemplateAreas: MKT_GRID_TEMPLATE_AREAS.mobile,
      gap: theme.spacing(3),
      padding: theme.spacing(4, 3),
      height: "100%",
      borderRadius: theme.spacing(1),
      border: `1px solid ${(_a = theme.vars.palette.grey) == null ? void 0 : _a[20]}`,
      background: (_b = theme.vars.palette.grey) == null ? void 0 : _b[0],
      [theme.containerQueries(MKT_OFFER_CONTAINER).up(MKT_CONTAINER_BREAKPOINT.tablet)]: {
        minHeight: "226px",
        gridTemplateColumns: `
        ${MKT_GRID_COLUMN_SIZES.img}
        ${MKT_GRID_COLUMN_SIZES.highlights}
        ${MKT_GRID_COLUMN_SIZES.divider}
        ${MKT_GRID_COLUMN_SIZES.OfferCriteriaCta}
      `,
        gridTemplateRows: "1fr",
        gridTemplateAreas: MKT_GRID_TEMPLATE_AREAS.tablet,
        gap: theme.spacing(0, 3),
        padding: theme.spacing(4),
        alignItems: "center"
      },
      [theme.containerQueries(MKT_OFFER_CONTAINER).up(MKT_CONTAINER_BREAKPOINT.desktop)]: {
        gridTemplateColumns: `
        ${MKT_GRID_COLUMN_SIZES.imgDesktop}
        ${MKT_GRID_COLUMN_SIZES.highlights}
        ${MKT_GRID_COLUMN_SIZES.divider}
        ${MKT_GRID_COLUMN_SIZES.OfferCriteria}
        ${MKT_GRID_COLUMN_SIZES.cta}
      `,
        gridTemplateAreas: MKT_GRID_TEMPLATE_AREAS.desktop,
        gap: theme.spacing(6),
        padding: theme.spacing(4, 6)
      }
    }
  };
});
const CardHeader = styled$1(Box)(({ theme }) => {
  var _a;
  return {
    [`#${MKT_CONTAINER_ID} &`]: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: theme.spacing(1),
      gridArea: MKT_GRID_AREAS.OFFER_HEADER,
      "& img": {
        width: "100%",
        minWidth: "116px",
        maxWidth: "186px",
        height: "auto"
      },
      "& small": {
        ...theme.typography.bodyXtraSmallRegular,
        color: (_a = theme.vars.palette.grey) == null ? void 0 : _a[70]
      }
    }
  };
});
const CardBody = styled$1(Box)(({ theme }) => ({
  [`#${MKT_CONTAINER_ID} &`]: {
    display: "contents"
  }
}));
const Divider = styled$1(Box)(({ theme }) => {
  var _a;
  return {
    [`#${MKT_CONTAINER_ID} &`]: {
      width: "1px",
      height: "100%",
      backgroundColor: (_a = theme.vars.palette.grey) == null ? void 0 : _a[10],
      display: "none",
      gridArea: MKT_GRID_AREAS.DIVIDER,
      [theme.containerQueries(MKT_OFFER_CONTAINER).up(MKT_CONTAINER_BREAKPOINT.tablet)]: {
        display: "block"
      }
    }
  };
});
function OfferCard({
  sx = {},
  index = 0,
  offer,
  sourceId,
  marketingClickId,
  isTestMode
}) {
  return /* @__PURE__ */ jsxs(
    OfferCardContainer,
    {
      sx,
      "data-testid": `offer-card-${offer.clientId}`,
      itemScope: true,
      itemProp: "item",
      itemType: "https://schema.org/FinancialProduct https://schema.org/LoanOrCredit",
      children: [
        /* @__PURE__ */ jsx("meta", { itemProp: "name", content: offer.clientName }),
        /* @__PURE__ */ jsxs(
          OfferCardLayout,
          {
            itemScope: true,
            itemProp: "provider",
            itemType: "https://schema.org/Organization",
            children: [
              /* @__PURE__ */ jsx("meta", { itemProp: "name", content: offer.clientName }),
              /* @__PURE__ */ jsxs(CardBody, { children: [
                /* @__PURE__ */ jsx(CardHeader, { children: /* @__PURE__ */ jsx(
                  OfferLogo,
                  {
                    logoUrl: offer.logoUrl,
                    clientId: offer.clientId,
                    clientName: offer.clientName,
                    nmls: offer.nmls
                  }
                ) }),
                /* @__PURE__ */ jsx(ProviderHighlights, { highlights: offer.highlights, clientId: offer.clientId }),
                /* @__PURE__ */ jsx(Divider, {}),
                /* @__PURE__ */ jsx(
                  OfferCriteria,
                  {
                    criteria: offer.criteria,
                    clientId: offer.clientId
                  }
                ),
                /* @__PURE__ */ jsx(
                  OfferCta,
                  {
                    clientId: offer.clientId,
                    clientName: offer.clientName,
                    ctaButtonText: offer.ctaButtonText,
                    ctaUrl: offer.ctaUrl,
                    ctaAdditionalText: offer.ctaAdditionalText,
                    sourceId,
                    marketingClickId,
                    isTestMode
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}
OfferCard.propTypes = {
  sx: PropTypes.object,
  index: PropTypes.number,
  offer: PropTypes.shape({
    clientId: PropTypes.string.isRequired,
    clientName: PropTypes.string.isRequired,
    logoUrl: PropTypes.string.isRequired,
    trustPilotUrl: PropTypes.oneOfType([() => null, PropTypes.string]),
    trustPilotBusinessId: PropTypes.oneOfType([() => null, PropTypes.string]),
    ctaButtonText: PropTypes.string.isRequired,
    ctaUrl: PropTypes.string.isRequired,
    ctaAdditionalText: PropTypes.string,
    highlights: PropTypes.arrayOf(PropTypes.string).isRequired,
    criteria: PropTypes.arrayOf(PropTypes.object).isRequired,
    nmls: PropTypes.string.isRequired
  }).isRequired,
  sourceId: PropTypes.string.isRequired,
  marketingClickId: PropTypes.string.isRequired,
  isTestMode: PropTypes.bool
};
const MarketPlaceContainer = styled(Box)(({ theme }) => ({
  [`#${MKT_CONTAINER_ID}&`]: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr",
    gap: theme.spacing(1),
    width: "100%",
    container: `${MKT_CONTAINER_ID} / inline-size`
  }
}));
const OffersContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "variant"
})(({ theme, variant }) => ({
  [`#${MKT_CONTAINER_ID} &`]: {
    display: "grid",
    gridAutoRows: "1fr",
    gap: theme.spacing(3),
    width: "100%",
    container: `${MKT_OFFERS_CONTAINER} / inline-size`
  },
  [theme.containerQueries(MKT_CONTAINER_ID).up(MKT_MINI_BREAKPOINT)]: {
    gridTemplateColumns: variant === "mini" ? "1fr 1fr 1fr" : "1fr"
  }
}));
const OfferContainer = styled(Box)(({ theme }) => ({
  [`#${MKT_CONTAINER_ID} &`]: {
    display: "flex",
    justifyContent: "center",
    width: "100%"
  }
}));
const Offers = ({
  marketingClickId,
  sourceId,
  environment,
  marketplaceVariant,
  maxOffers
}) => {
  const isTestMode = useIsTestMode();
  const { offers, offersError, offersSuccess } = useFetchOffers({ environment });
  const visibleOffers = getVisibleOffers(marketplaceVariant, maxOffers, offers);
  if (marketingClickId === null || !offersSuccess || offersError) {
    if (offersError) {
      console.error({ offersError });
    }
    return /* @__PURE__ */ jsx(SkeletonMarketplace, {});
  }
  return /* @__PURE__ */ jsxs(OffersContainer, { "data-testid": `offers-container-${marketplaceVariant}`, variant: marketplaceVariant, children: [
    /* @__PURE__ */ jsx("meta", { itemProp: "numberOfItems", content: visibleOffers.length }),
    /* @__PURE__ */ jsx("meta", { itemProp: "itemListOrder", content: "https://schema.org/ItemListOrderAscending" }),
    visibleOffers.map((offer, index) => /* @__PURE__ */ jsxs(
      OfferContainer,
      {
        className: "marketplace-card",
        itemProp: "itemListElement",
        itemScope: true,
        itemType: "https://schema.org/ListItem",
        children: [
          /* @__PURE__ */ jsx(
            OfferCard,
            {
              index,
              isTestMode,
              marketingClickId: marketingClickId ?? "",
              offer,
              sourceId
            }
          ),
          /* @__PURE__ */ jsx("meta", { itemProp: "position", content: index + 1 })
        ]
      },
      index
    ))
  ] });
};
Offers.propTypes = {
  marketingClickId: PropTypes.string,
  sourceId: PropTypes.string,
  environment: PropTypes.oneOf(Object.values(ENVIRONMENTS)),
  marketplaceVariant: PropTypes.oneOf(Object.values(VARIANTS)),
  maxOffers: PropTypes.number
};
const isValidBackgroundValue = (value) => {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!isWindowDefined()) {
    const cssBackgroundRegex = /^(#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})|(rgb|hsl)a?\([^)]*\)|url\([^)]*\)|(linear|radial|conic)-gradient\([^)]*\)|repeat(-x|-y)?|no-repeat|center|top|bottom|left|right|contain|cover|auto|inherit|initial|revert|unset|[a-zA-Z]+|[0-9]+(%|px|em|rem|vh|vw|vmin|vmax)?|calc\([^)]*\)|var\([^)]*\)|\s|,)+$/i;
    return cssBackgroundRegex.test(trimmed);
  }
  const el = window == null ? void 0 : window.document.createElement("div");
  el.style.background = trimmed;
  return el.style.background !== "";
};
const CustomOfferCardContainer = styled$1(Box, {
  shouldForwardProp: (prop) => prop !== "containerId"
})(({ theme, containerId }) => ({
  [`#${containerId}&`]: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    container: `${containerId} / inline-size`
  }
}));
const CustomOfferCardLayout = styled$1(Box, {
  shouldForwardProp: (prop) => prop !== "containerId" && prop !== "fillColor"
})(({ theme, containerId, fillColor }) => {
  var _a;
  return {
    [`#${containerId} &`]: {
      width: "100%",
      minWidth: "272px",
      maxWidth: "1376px",
      display: "grid",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "repeat(3, auto)",
      gridTemplateAreas: CUSTOM_OFFER_GRID_TEMPLATE_AREAS.mobile,
      gap: theme.spacing(3),
      padding: theme.spacing(4, 3),
      height: "100%",
      borderRadius: theme.spacing(1),
      border: `1px solid ${fillColor === "gradient" || isValidBackgroundValue(fillColor) && fillColor !== "white" ? "transparent" : (_a = theme.vars.palette.grey) == null ? void 0 : _a[20]}`,
      background: (() => {
        var _a2, _b, _c;
        if (fillColor === "gradient") {
          return `linear-gradient(109deg, ${(_a2 = theme.vars.palette.primary) == null ? void 0 : _a2[5]} 25.28%, ${(_b = theme.vars.palette.primary) == null ? void 0 : _b[10]} 74.72%)`;
        }
        return isValidBackgroundValue(fillColor) ? fillColor : (_c = theme.vars.palette.grey) == null ? void 0 : _c[0];
      })(),
      backgroundClip: "padding-box",
      [theme.containerQueries(containerId).up(MKT_CONTAINER_BREAKPOINT.tablet)]: {
        minHeight: "226px",
        gridTemplateRows: "1fr",
        gridTemplateColumns: `
        ${CUSTOM_OFFER_GRID_COLUMN_SIZES.img}
        ${CUSTOM_OFFER_GRID_COLUMN_SIZES.body}
        ${CUSTOM_OFFER_GRID_COLUMN_SIZES.cta}
      `,
        gridTemplateAreas: CUSTOM_OFFER_GRID_TEMPLATE_AREAS.desktop,
        gap: theme.spacing(0, 3),
        padding: theme.spacing(4),
        alignItems: "center"
      },
      [theme.containerQueries(containerId).up(MKT_CONTAINER_BREAKPOINT.desktop)]: {
        gridTemplateColumns: `
        ${CUSTOM_OFFER_GRID_COLUMN_SIZES.imgDesktop}
        ${CUSTOM_OFFER_GRID_COLUMN_SIZES.bodyDesktop}
        ${CUSTOM_OFFER_GRID_COLUMN_SIZES.ctaDesktop}
      `,
        gap: theme.spacing(6),
        padding: theme.spacing(4, 6)
      }
    }
  };
});
const CustomOfferCardHeader = styled$1(Box, {
  shouldForwardProp: (prop) => prop !== "containerId"
})(({ theme, containerId }) => ({
  [`#${containerId} &`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gridArea: CUSTOM_OFFER_GRID_AREAS.CUSTOM_OFFER_HEADER
  }
}));
const CustomOfferCardIllustration = styled$1("img", {
  shouldForwardProp: (prop) => prop !== "containerId"
})(({ theme, containerId }) => ({
  [`#${containerId} &`]: {
    width: "124px",
    minWidth: "116px",
    maxWidth: "132px",
    height: "auto",
    objectFit: "contain",
    [theme.containerQueries(containerId).up(MKT_CONTAINER_BREAKPOINT.tablet)]: {
      width: "100%"
    }
  }
}));
const CustomOfferCardBody = styled$1(Box, {
  shouldForwardProp: (prop) => prop !== "containerId"
})(({ theme, containerId }) => ({
  [`#${containerId} &`]: {
    gridArea: CUSTOM_OFFER_GRID_AREAS.CUSTOM_OFFER_BODY
  }
}));
const CustomOfferCardCta = styled$1(Box, {
  shouldForwardProp: (prop) => prop !== "containerId"
})(({ theme, containerId }) => ({
  [`#${containerId} &`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gridArea: CUSTOM_OFFER_GRID_AREAS.CUSTOM_OFFER_CTA,
    "& a": {
      width: "100%",
      background: "transparent",
      [theme.containerQueries(containerId).up(MKT_CONTAINER_BREAKPOINT.tablet)]: {
        width: "177px"
      }
    }
  }
}));
const CustomOfferCard = ({
  sx = {},
  environment = ENVIRONMENTS.PRODUCTION,
  id = CUSTOM_OFFER_CONTAINER_ID,
  dataTestId = "custom-offer-card",
  config,
  sourceId,
  marketingClickId,
  children,
  isTestMode = false
}) => {
  const ctaParams = {
    sourceid: sourceId,
    marketingclickid: marketingClickId
  };
  if (isTestMode) {
    ctaParams["test"] = true;
  }
  const modifiedCtaUrl = addQueryParams(config.cta.redirectUrl, ctaParams);
  return /* @__PURE__ */ jsx(
    CustomOfferCardContainer,
    {
      id,
      containerId: id,
      sx,
      "data-testid": dataTestId,
      className: `env-${environment}`,
      children: /* @__PURE__ */ jsxs(CustomOfferCardLayout, { containerId: id, fillColor: (config == null ? void 0 : config.fillColor) || "white", children: [
        /* @__PURE__ */ jsx(
          CustomOfferCardHeader,
          {
            containerId: id,
            "data-testid": `${dataTestId}-header`,
            children: (config == null ? void 0 : config.imageSrc) && /* @__PURE__ */ jsx(
              CustomOfferCardIllustration,
              {
                containerId: id,
                src: config.imageSrc,
                "data-testid": `${dataTestId}-image`,
                alt: config.imageAlt || "",
                loading: "lazy"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(
          CustomOfferCardBody,
          {
            containerId: id,
            "data-testid": `${dataTestId}-body`,
            children
          }
        ),
        /* @__PURE__ */ jsx(
          CustomOfferCardCta,
          {
            containerId: id,
            "data-testid": `${dataTestId}-cta`,
            children: /* @__PURE__ */ jsx(
              BYOButton,
              {
                className: FOCUS_OUTLINE_CLASS,
                color: "green",
                style: "outlined",
                href: modifiedCtaUrl,
                "data-testid": `cta-button-${dataTestId}`,
                children: config.cta.ctaText
              }
            )
          }
        )
      ] })
    }
  );
};
CustomOfferCard.propTypes = {
  sx: PropTypes.object,
  environment: PropTypes.string,
  id: PropTypes.string,
  dataTestId: PropTypes.string,
  config: PropTypes.shape({
    imageSrc: PropTypes.string.isRequired,
    cta: PropTypes.shape({
      redirectUrl: PropTypes.string.isRequired,
      ctaText: PropTypes.string.isRequired
    }).isRequired,
    fillColor: PropTypes.string,
    imageAlt: PropTypes.string
  }).isRequired,
  sourceId: PropTypes.string,
  marketingClickId: PropTypes.string.isRequired,
  children: PropTypes.node,
  isTestMode: PropTypes.bool
};
const MarketplaceHeaderContainer = styled$1(Box)(({ theme }) => {
  var _a;
  return {
    [`#${MKT_CONTAINER_ID} &`]: {
      display: "flex",
      justifyContent: "center",
      "& .marketplace-intro": {
        width: "100%",
        maxWidth: "1376px"
      },
      "& span": {
        ...theme.typography.bodyXtraSmallRegularMobile,
        margin: 0,
        color: (_a = theme.vars.palette.grey) == null ? void 0 : _a[70],
        width: "100%",
        [theme.breakpoints.up(BREAKPOINT_DIMENSIONS.small)]: {
          ...theme.typography.bodyXtraSmallRegular
        }
      }
    }
    // Future styles for buttons, filters can be added here
  };
});
const MarketplaceHeader = ({ sx }) => {
  return /* @__PURE__ */ jsx(MarketplaceHeaderContainer, { sx, "data-testid": "marketplace-header", children: /* @__PURE__ */ jsx("div", { className: "marketplace-intro", children: /* @__PURE__ */ jsx("span", { className: "disclaimer", "data-testid": "marketplace-sponsored-results", children: "Sponsored Results" }) }) });
};
MarketplaceHeader.propTypes = {
  sx: PropTypes.object
};
export {
  CustomOfferCard as C,
  MarketplaceHeader as M,
  OfferCard as O,
  SkeletonMarketplace as S,
  OfferContainer as a,
  Offers as b,
  OffersContainer as c,
  MarketPlaceContainer as d,
  StyledSkeletonNavBarDesktop as e
};
//# sourceMappingURL=MarketplaceHeader-DJBJR-xI.js.map
